import { WabunkaExperienceEventReservationType } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_event_reservation_type';

import { useRuntimeConfigKey, type UseRuntimeConfig } from '@/injectionKeys';
import type { PaymentMethod } from '@/wabunka-src/constants/paymentMethod';

/**
 * 支払い方法を取得する。
 *
 * `USE_FINCODE` が無効なときは常に `payjp`。
 * 有効なときは予約種別で振り分ける（B-1・要件2）:
 *   - 即時予約 → `payjp`（確定直後に自動キャプチャされ、オーソリ失効リスクが無い）
 *   - リクエスト予約・種別未確定 → `fincode`（Fincode の長期オーソリを使う）
 *
 * 安全側はオーソリ期間の長い Fincode。即時予約と「明確に判定できた」ときだけ Pay.jp に倒し、
 * それ以外（リクエスト予約 / UNKNOWN / undefined）は失効リスクを避けるため Fincode を選ぶ。
 *
 * @param reservationType 予約種別（`effectiveReservationType ?? reservationType` を渡す）。
 *   省略・未確定（イベント未ロード / UNKNOWN）の場合は安全側の `fincode` に倒す。
 */
export const useGetPaymentMethod = (reservationType?: MaybeRefOrGetter<WabunkaExperienceEventReservationType | undefined>): { paymentMethod: Ref<PaymentMethod> } => {
  const useRuntimeConfig = inject(useRuntimeConfigKey) as UseRuntimeConfig;
  const runtimeConfig = useRuntimeConfig();
  const paymentMethod = computed<PaymentMethod>(() => {
    if (!runtimeConfig.public.USE_FINCODE) return 'payjp';

    // 即時予約と「明確に判定できた」ときだけ Pay.jp。
    // リクエスト予約・種別未確定（イベント未ロード / UNKNOWN / undefined）は、
    // オーソリ失効リスクを避けるため安全側の Fincode（長期オーソリ）に倒す。
    return toValue(reservationType) === WabunkaExperienceEventReservationType.EXPERIENCE_EVENT_RESERVATION_TYPE_INSTANT ? 'payjp' : 'fincode';
  });

  return {
    paymentMethod,
  };
};
